export default {
  USER: 'user',
  OCCUPATION: 'occupation',
}
